import { useWatch } from 'react-hook-form';

import { useBookingPaymentMethod } from 'reservations/booking/providers/BookingProvider';
import { validateExpiration } from 'reservations/payments/helpers/validateExpiration';
import { useDinerPaymentMethods } from 'reservations/payments/hooks/useDinerPaymentMethods';

export const useChecklessPaymentMethod = () => {
  const { hasCardOnFile, ...bookingPaymentMethod } = useBookingPaymentMethod();
  const date = useWatch({
    name: 'date'
  });
  const { defaultPaymentMethod: dinerPaymentMethod } = useDinerPaymentMethods();
  return hasCardOnFile
    ? {
        ...bookingPaymentMethod,
        isExpirationValid: validateExpiration(
          bookingPaymentMethod.cardExpMonth!,
          bookingPaymentMethod.cardExpYear!,
          new Date(date)
        )
      }
    : dinerPaymentMethod;
};
